export default __webpack_public_path__ + "static/plx-br-9ec684f1090d85919f182ec6182ec4bf.jpg";